module.exports = __webpack_public_path__ + "static/404.a8e5401d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/404.png
// module id = 7149
// module chunks = 162898551421021